<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Potwierdź realizację' }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        Potwierdzam realizację zajęć.
        <p *ngIf="error" style="color: red;">
            Wystąpił błąd. Zwweryfikujj czy klient ma odpowiednią usługę na karcie!
        </p>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Anuluj'}}
        </button>
        <button
                mat-button
                class="mr-8"
                [disabled]="loadingData"
                (click)="confirm()"
                aria-label="Confirm">
            {{'Potwierdź'}}
        </button>

    </div>
</div>
